/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import { Button } from "@heroui/button";

import BlogCard from "@/components/element/BlogCard";

type blogData = {
  meta: {
    slug: string;
  };
  title: string;
  created_at: string;
  thumbnail: any;
  tags: string[];
};

interface LatestBlogsSliderProps {
  latestBlogsData: blogData[];
}

const LatestBlogsSlider: React.FC<LatestBlogsSliderProps> = ({
  latestBlogsData,
}) => {
  const router = useRouter();
  const sliderRef = React.useRef<any>(null);
  const [isReachedEnd, setIsReachedEnd] = useState<boolean>(false);
  const [isReachedStart, setIsReachedStart] = useState(false);

  const handlePrev = () => {
    sliderRef.current.swiper.slidePrev();
  };

  const handleNext = () => {
    sliderRef.current.swiper.slideNext();
  };

  // Extreme End Position Checker
  useEffect(() => {
    if (sliderRef.current?.swiper) {
      const swiper = sliderRef.current.swiper;

      setIsReachedStart(swiper.isBeginning);
      setIsReachedEnd(swiper.isEnd);

      // Listen for changes in swiper state
      swiper.on("slideChange", () => {
        setIsReachedStart(swiper.isBeginning);
        setIsReachedEnd(swiper.isEnd);
      });
    }
  }, [sliderRef]);

  return (
    <div className="w-full">
      <Swiper
        ref={sliderRef}
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        }}
        className="w-full h-full"
        slidesPerView={1}
        spaceBetween={20}
      >
        {latestBlogsData.map((blog, index) => (
          <SwiperSlide key={index} className="!h-auto">
            <BlogCard blogData={blog} router={router} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex xl:hidden w-full items-center justify-center gap-3 md:gap-4 mt-6">
        <Button
          isIconOnly
          className="w-10 h-10 bg-[#F6F6F6] rounded-full"
          isDisabled={isReachedStart}
          radius="full"
          variant="flat"
          onPress={handlePrev}
        >
          <img
            alt="Left Arrow"
            className="w-5 h-5 object-contain rotate-180"
            height={20}
            src="/icons/arrow_left_black.svg"
            width={20}
          />
        </Button>
        <Button
          isIconOnly
          className="w-10 h-10 bg-[#F6F6F6] rounded-full"
          isDisabled={isReachedEnd}
          radius="full"
          variant="flat"
          onPress={handleNext}
        >
          <img
            alt="Left Arrow"
            className="w-5 h-5 object-contain"
            height={20}
            src="/icons/arrow_left_black.svg"
            width={20}
          />
        </Button>
      </div>
    </div>
  );
};

export default LatestBlogsSlider;
